import styled from 'styled-components'

export const Wrapper = styled.div`
  height: ${({ height }) => height || '40px'};
  position: sticky;
  top: 0;
  z-index: 2;
  margin-bottom: 0;
  transition: box-shadow 0.2s linear;
  display: flex;
  justify-content: space-between;
  background-color: var(--bg);
  padding: 0px 16px;
`

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const Logo = styled.div`
  padding: 0px 16px;
  img { height: 28px; }
  cursor: default;
`

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Separator = styled.div`
  border-left: 1px solid rgba(0,0,0,.1);
  height: 60%;
`

const hoverStyle = `
  cursor: pointer;
  :hover {
    color: var(--primary);
  }
`

export const CustomMenuDropdown = styled.div`
  background-color: #fff;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  min-width: 200px;
`

export const MenuItem = styled.div`
  padding: 6px 12px;
  cursor: default;
  transition: all 0.2s;
  ${({ color }) => color ? `background: ${color}; color: #fff;` : 'color: rgba(0,0,0,.88);'}
  ${({ useBorder }) => useBorder ? 'border: 1px solid var(--primary); border-top: none;' : ''}
  display: flex;
  justify-content: space-between;

  .hoverable { ${hoverStyle} }
`

export const ColMenu = styled.div`
  width: ${({ width }) => width || '50%'};
  ${({ left }) => left ? 'border-right: 1px solid rgba(0,0,0,.15)' : ''};
  text-align: center;
  ${hoverStyle}
`
